<template>
  <vue-flickity
    ref="carousel"
    :options="options"
  >
    <slot />
  </vue-flickity>
</template>

<script>


export default {
  props: {
    options: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      activeIndex: 0
    }
  },
  computed: {
  },
  mounted () {
    setTimeout(() => { this.$refs.carousel.reloadCells() }, 100)
    setTimeout(() => { this.$refs.carousel.reloadCells() }, 200)
    setTimeout(() => { this.$refs.carousel.reloadCells() }, 300)
    setTimeout(() => { this.$refs.carousel.reloadCells() }, 400)

    this.$refs.carousel.on('change', index => {
      setTimeout(() => { this.$refs.carousel.reloadCells() }, 100)
      setTimeout(() => { this.$refs.carousel.reloadCells() }, 200)
      setTimeout(() => { this.$refs.carousel.reloadCells() }, 300)
      setTimeout(() => { this.$refs.carousel.reloadCells() }, 400)
    })
  },
  methods: {
  }
}
</script>
